import React, { useState } from 'react';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import Sidebar from './components/Sidebar';
import StyleSwitcher from './components/StyleSwitcher';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import './styles/index.css';

const AppContent = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isRTL } = useLanguage();

  return (
    <div className="flex flex-col min-h-screen relative font-poppins bg-bg-black-900 text-text-black-900" dir={isRTL ? 'rtl' : 'ltr'}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Burger button */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className={`fixed top-5 ${isRTL ? 'left-5' : 'right-5'} z-50 md:hidden bg-bg-black-100 h-10 w-10 border border-bg-black-50 rounded flex items-center justify-center cursor-pointer`}
      >
        <span className="h-0.5 w-5 bg-skin-color inline-block relative nav-icon"></span>
      </button>

      {/* Main content */}
      <main className={`flex-grow ${isRTL ? 'md:pr-64' : 'md:pl-64'}`}>
        <Home />
        <About />
        <Skills />
        <Portfolio />
        <Contact />
      </main>

      <StyleSwitcher />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
